// extracted by mini-css-extract-plugin
export default {"faq-form":"FAQForm_faq-form__ggesi","faq-form__toolbar":"FAQForm_faq-form__toolbar__3MROt","faq-form--edit":"FAQForm_faq-form--edit__zLOjz"};